module.exports = __webpack_public_path__ + "img/web2.c9810b92.png";